<div class="material-action-button" [class.lift-higher]="liftHigher()" [class.lift-higher-2]="liftHigher2()">
  @if (liftHigher2()) {
    <a
      mat-mini-fab
      class="mat-accent"
      [attr.id]="id() || null"
      [routerLink]="routerLink()"
      [matTooltip]="actionName()"
      matTooltipPosition="left"
      [attr.aria-label]="actionName() || null"
    >
      <mat-icon>{{ icon() }}</mat-icon>
    </a>
  } @else {
    <a
      mat-fab
      class="mat-primary"
      [attr.id]="id() || null"
      [routerLink]="routerLink()"
      [matTooltip]="actionName()"
      matTooltipPosition="left"
      [attr.aria-label]="actionName() || null"
    >
      <mat-icon>{{ icon() }}</mat-icon>
    </a>
  }
</div>
